export default {
  setData (state, payload) {
    if (!payload) {
      return
    }

    state.data = payload
  },
  clearState (state) {
    state.data = []
  }
}